import React from 'react';

import Page from '@Containers/Page';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';

import './DNSMaintenance.custom.scss';
import './DNSMaintenance.theme.scss';

function DNSMaintenance() {
  return (
    <Page
      withHeader
      headerType="clean"
      withFooter
      pageClassName="react-page-static dns-maintenance-page"
      className="react-page-static__wrapper">
      <div className="dns-maintenance-page__header page-container--hexagons left-gutter right-gutter">
        <h1 className="dns-maintenance-page__header_title u-els-font-size-h2">www.reaxys.com</h1>
        <p className="dns-maintenance-page__header_text">
          We apologise for the inconvenience but Reaxys no longer supports the URL that you have used. <br />
          Please use
          <a className="blue-link" tabIndex="0" target="_blank" href="https://www.reaxys.com" rel="noreferrer">
            https://www.reaxys.com
          </a>{' '}
          to reach Reaxys and please update your bookmarks.
          <br />
          The following is a list of URLs that are no longer supported or have been configured to redirect to
          <a className="blue-link" tabIndex="0" target="_blank" href="https://www.reaxys.com" rel="noreferrer">
            https://www.reaxys.com
          </a>
          .
          <br />
          Please contact our support team if you have any questions
        </p>
      </div>
      <div className="react-page-static__content left-gutter right-gutter">
        <div className="dns-maintenance-page__links">
          <div className="dns-maintenance-page__links_block">
            <span>Reaxys obsolete names</span>
            <span>acert-www.reaxys.com</span>
            <span>alt-www.reaxys.com</span>
            <span>www-ipacl.reaxys.com</span>
          </div>
          <div className="dns-maintenance-page__links_block">
            <span>Reaxys redirects to www.reaxys.com</span>
            <span>reaxys.com</span>
            <span>batch-www.reaxys.com</span>
            <span>beta.reaxys.com</span>
            <span>cn-www.reaxys.com</span>
            <span>fl-www.reaxys.com</span>
            <span>www.inspiringchemistry.reaxys.com</span>
            <span>new-cert.reaxys.com</span>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default withCombinedRouteParams(DNSMaintenance);
